// tslint:disable: object-literal-sort-keys
export const SCAttributes = {
  SC_ACTIVITY_NAME: "marksc_activityname",
  SC_AGENCY_DR_NAME: "agency_drname",
  SC_CALENDAR_DATE: "calendar_date",
  SC_CALENDAR_MONTH: "calendar_month",
  SC_CALENDAR_QUARTER: "calendar_quarter",
  SC_CALENDAR_WEEK: "calendar_week",
  SC_CALENDAR_YEAR: "calendar_year",
  SC_CLIENT_EC_FULLNAME: "client_ecfullname",
  SC_CLIENT_EC_LEGAL_ID: "client_eclegalid",
  SC_CLIENT_EC_COM_ID: "client_eccomid",
  SC_CLIENT_EC_COM_CTRY: "client_eccomctrycode",
  SC_CLIENT_GEN_ID: "clientgen_id",
  SC_CLIENT_GROUPNAME: "client_grpname",
  SC_CLIENT_GRPID: "client_grpid",
  SC_CLIENT_ID: "client_id",
  SC_CLIENT_LEID: "client_leid",
  SC_CLIENT_LENAME: "client_lename",
  SC_CLIENT_LE_CTRY_GRP_NAME: "client_lecomctrygrpname",
  SC_CLIENT_LE_CTRY_NAME: "client_lecomctryname",
  SC_CLIENT_LE_REG_NAME: "client_lecomregname",
  SC_CLIENT_LE_SUBREG_NAME: "client_lecomsubregname",
  SC_CLIENT_LE_TYPEL2_NAME: "client_letypol2",
  SC_CLIENT_LE_TYPEL3_NAME: "client_letypol3",
  SC_CLIENT_LE_TYPO_L1: "client_letypol1",
  SC_CLIENT_SUBGROUPNAME: "client_subgrpname",
  SC_CLIENT_TYPOLOGY_LEVEL2: "client_grptypl2name",
  SC_CLIENT_TYPOLOGY_LEVEL3: "client_grptypl3name",
  SC_CREDIT_DATE: "marksc_creditdate",
  SC_DR_NAME: "fpvtrade_ptfmnemo",
  SC_EVENTS_COUNT: "cc_events_count",
  SC_EXANTE_FINANCIALINSTRUMENT_ONEOFF: "cc_exante_financialinstrument_oneoff",
  SC_EXANTE_FINANCIALINSTRUMENT_ONGOING:
    "cc_exante_financialinstrument_ongoing",
  SC_EXANTE_SERVICE_ONEOFF: "cc_exante_service_oneoff",
  SC_EXANTE_SERVICE_ONGOING: "cc_exante_service_ongoing",
  SC_EXANTE_SERVICE_TRANSACTION: "cc_exante_service_transaction",
  SC_EXPOST_FINANCIALINSTRUMENT_ONEOFF: "cc_expost_financialinstrument_oneoff",
  SC_EXPOST_FINANCIALINSTRUMENT_ONGOING:
    "cc_expost_financialinstrument_ongoing",
  SC_EXPOST_SERVICE_ONEOFF: "cc_expost_service_oneoff",
  SC_EXPOST_SERVICE_ONGOING: "cc_expost_service_ongoing",
  SC_EXPOST_SERVICE_TRANSACTION: "cc_expost_service_transaction",
  SC_FINAL_CLIENT_CAMBIST_NAME: "client_finalclientcambistname",
  SC_FINAL_CLIENT_FOLOWUP_CLASS_NAME: "client_finalclientfolowupclassname",
  SC_FINAL_CLIENT_MIFID_CATEGORY: "client_finalclientmifidcategory",
  SC_FPV_BUMNEMO: "fpv_bumnemo",
  SC_FPV_BUSINESS_L1: "fpv_business_l1",
  SC_FPV_BUSINESS_L2: "fpv_business_l2",
  SC_FPV_BUSINESS_L3: "fpv_business_l3",
  SC_FPV_GOP: "fpv_gop",
  SC_FPV_LABEL: "fpv_label",
  SC_FPV_PCMNEMO: "fpv_pcmnemo",
  SC_FPV_REGION: "fpv_region",
  SC_FPV_SALES_COUNTRY: "fpv_sales_country",
  SC_FPV_SALES_REGION: "fpv_sales_region",
  SC_FPV_SALES_ZONE: "fpv_sales_zone",
  SC_FPV_SBUMNEMO: "fpv_sbumnemo",
  SC_FPV_SSBL: "fpv_ssbl",
  SC_FPV_TRADE_BUMNEMO: "fpvtrade_bumnemo",
  SC_FPV_TRADE_GOP: "fpvtrade_gopmnemo",
  SC_FPV_TRADE_INVFLOWFIN: "fpvtrd_invflowfin",
  SC_FPV_TRADE_LABEL: "fpvtrade_pclabel",
  SC_FPV_TRADE_PC: "fpvtrade_pcmnemo",
  SC_FPV_TRADE_SBU: "fpvtrade_sbu",
  SC_FPV_TRADE_SSBL: "fpvtrade_ssbl",
  SC_FPV_TRADE_SUBMNEMO: "fpvtrade_sbumnemo",
  SC_INVESTMENT_PURPOSE: "markdeals_investmentpurpose",
  SC_ISSUER_NAME: "issuer_issuername",
  SC_MANDATE_COUNTRY: "marksc_mandatecountry",
  SC_MANDATE_REGION: "marksc_mandateregion",
  SC_MANDATE_ZONE: "marksc_mandatezone",
  SC_MARKDEALS_COMMITMENTS: "markdeals_comments",
  SC_MARKDEALS_DEAL_CODE: "markdeals_sourcedealcode",
  SC_MARKDEALS_ELIOTLOGIN: "markdeals_eliotlogin",
  SC_MARKDEALS_EQYFI: "markdeals_eqyfi",
  SC_MARKDEALS_FILE_CODE: "markdeals_filecode",
  SC_MARKDEALS_INPUT_DEAL_CODE: "markdeals_inputdealcode",
  SC_MARKDEALS_MARKET_TYPE: "markdeals_markettype",
  SC_MARKDEALS_MATURITY_DATE: "markdeals_matdate",
  SC_MARKDEALS_MEDIA_CODE: "markdeals_mediacode",
  SC_MARKDEALS_MEDIA_NAME: "markdeals_medianame",
  SC_MARKDEALS_PACKAGE_CODE: "markdeals_packagecode",
  SC_MARKDEALS_PRIMARY_SECONDARY: "markdeals_primarysecondary",
  SC_MARKDEALS_PRODUCT_FAMILY_NAME: "markdeals_productfamilyname",
  SC_MARKDEALS_PRODUCT_NAME: "markdeals_productname",
  SC_MARKDEALS_QUANTITY: "markdeals_quantity",
  SC_MARKDEALS_SALES_AUTHOR: "markdeals_salesauthor",
  SC_MARKDEALS_SCORE_UPDATED_DATE: "markdeals_scoreupdateddate",
  SC_MARKDEALS_SUB_DEAL_TYPE_NAME: "markdeals_subdealtypename",
  SC_MARKDEALS_TRADE_DATE: "markdeals_tradedate",
  SC_MARKDEALS_UNDERLYING_CODE: "markdeals_Underlyingcode",
  SC_MARKDEALS_VALUE_DATE: "markdeals_valuedate",
  SC_MARKDEALS_WAY: "markdeals_way",
  SC_MARK_BUSTYPE: "marksc_bustype",
  SC_MARK_IS_ELEC: "marksc_iselec",
  SC_MARK_NEGOTIATED_CURRENCY: "marksc_negotiatedcurrency",
  SC_MARK_NOMINAL_CURRENCY: "marksc_nominalcurrency",
  SC_MARK_STEP_GROUP: "marksc_stepgroup",
  SC_MARK_SUB_STEP_LEVEL: "marksc_substeplevel",
  SC_OE_RES_CTRY_NAME: "fpv_oeresctryname",
  SC_OE_RES_REG_CODE: "fpv_oeresregcode",
  SC_OE_SHORT_LABEL: "fpv_oeshortlabel",
  SC_PERIOD_MONTH_ID: "period_month_id",
  SC_PERIOD_MONTH_LABEL: "period_month_label",
  SC_PRODUCT_CATEGORY_NAME: "product_categoryname",
  SC_PRODUCT_LEVEL1: "product_l1",
  SC_PRODUCT_LEVEL2: "product_l2",
  SC_PRODUCT_LEVEL3: "product_l3",
  SC_PRODUCT_LEVEL4: "product_l4",
  SC_SALESBEN_ASSIGNCLOSINGDATE: "salesben_assignclosingdate",
  SC_SALESBEN_BUNAME: "salesben_buname",
  SC_SALESBEN_DESK: "salesben_desk",
  SC_SALESBEN_SALES: "salesben_sales",
  SC_SALESBEN_TEAM: "salesben_team",
  SC_SALESBEN_TEAM_LNAME: "salesben_teamlname",
  SC_SOURCE_APP_MNEMO: "marksc_sourceappmnemo",
  SC_SPARK_CLIENT: "sparkproduct_clientspark",
  SC_SPARK_IDMONTAGE: "sparkproduct_idmontage",
  SC_SPARK_LAUNCH_DATE: "sparkproduct_launchdate",
  SC_SPARK_PRODUCT: "sparkproduct_productname",
  SC_SPARK_RTFE_ID: "markspark_rtfeid",
  SC_SPARK_SALESDESK: "sparkproduct_salesdesk",
  SC_SPARK_VALEDATE: "sparkproduct_valuedate",
  SC_SUB_GRP_ID: "client_subgrpid",
  SC_TICKER: "marksc_scticker",
  SC_BE_SHORT_LABEL: "fpv_beshortlabel",
  SC_GOP_LABEL: "fpv_goplabel",
  SC_BE_SHORT_MNEMO: "fpv_beshortmnemo",
  SC_CLI_GRP_TYPEL1: "client_grptypl1name",
  SC_CLI_GRP_COM_REG_NAME: "client_grpcomregname",
  SC_CLI_GRP_CTRY: "client_grpcomctryname",
  SC_TRADE_BE_SHORT_MNEMO: "fpvtrade_beshortmnemo",
  SC_TRADE_SBU: "fpvtrade_sbu",
  SC_TRADE_SUB_MNEMO: "fpvtrade_sbumnemo",
  SC_TRADE_SSBL: "fpvtrade_ssbl",
  SC_FPV_TRADE_NEGO_ENTITY_REGION: "fpvtrade_negoentityregion",
  SC_PO_GRP_FULLNAME: "po_grpfullname",
  SC_PO_GRP_ID: "po_grpid",
  SC_PO_GRP_CTRY_NAME: "po_grpctryname",
  SC_DEAL_X_ONE_INSTRUMENT: "markdeals_xoneinstrument",
  SC_BUDGET_BU: "sc_budget_bu",
  SC_PO_LE_FULLNAME: "po_lefullname",
  SC_PO_LE_ID: "po_leid",
  SC_CLI_MARK_CURRENCY_EMG10: "markdeals_currency_emg10",
  SC_CLI_MARK_CURRENCY_ZONES: "markdeals_currency_zones",
  SC_CLI_MARK_CURRENCY: "markdeals_currency",
  SC_TEAM_ACTIVITY: "salesben_teamactivity",
  SC_TEAM_DESK: "salesben_teamdesk",
  SALESBEN_SALES_LOCATION: "salesben_saleslocation",
};
